module.exports = __webpack_public_path__ + "assets/img/media_31.44590eda.png";